import 'assets/css/date-picker.css';
import Svg from 'assets/img/date-icon.svg';
import 'react-multi-date-picker/styles/layouts/mobile.css';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { DateObject } from 'react-multi-date-picker';
import { digitsFaToEn } from 'persian-tools2';
import { Box, Typography, useMediaQuery } from '@mui/material';

const style = {
  container: {
    position: 'relative',
    width: '100%',
    height: { xs: '47px', md: '64px' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    overflow: 'hidden',
    borderRadius: '16px',
    marginBottom: '18px',
    border: '1px solid #FFFFFF',
    boxShadow: '1px 1px 2px 0px #00000029'
  },
  header: {
    color: '#707070',
    fontSize: { xs: '14px', md: '20px' },
    textAlign: 'left',
    margin: 'auto',
    position: 'absolute',
    fontWeight: '400',
    left: '16px'
  }
};

const weekDays = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'];
export const ReportCustomDatePicker = ({
  label,
  value,
  onChange,
  setHideModal,
  minDate,
  maxDate
}) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  const onChangeHandler = (date) => {
    let object = { date };
    const persianDate = digitsFaToEn(new DateObject(object).format());
    onChange(persianDate);
  };

  return (
    <Box sx={style.container}>
      <Typography sx={style.header}>
        Choose {label === 'start' ? 'Start Date' : 'End Date'}
      </Typography>
      <DatePicker
        onOpen={() => setHideModal(true)}
        onClose={() => setHideModal(false)}
        className="rmdp-mobile"
        weekDays={weekDays}
        value={value}
        onChange={onChangeHandler}
        minDate={minDate}
        maxDate={maxDate}
        calendar={persian}
        locale={persian_fa}
        inputMode="none"
        calendarPosition="bottom-start"
        fixMainPosition={true}
        monthYearSeparator=" ،"
        mobileLabels={{
          OK: 'Select',
          CANCEL: 'Cancel'
        }}
      />
      <img
        src={Svg}
        alt=""
        style={{
          position: 'absolute',
          right: '16px',
          zIndex: 0,
          margin: '0 10px',
          width: isDesktop && '32px',
          height: isDesktop && '32px'
        }}
      />
    </Box>
  );
};
